import IframeResizer from "iframe-resizer-react";
import { getActiveFlightSearchProvider } from "./providers";

const WRAPPER_CLASS =
  // pt-5 added to match the existing pl-5/pr-5 (20px) gap — the iframe was
  // flush against the rounded top edge. Bottom stays deeper at pb-10 (40px).
  "pt-5 pb-10 pl-5 pr-5 w-full relative mt-8 rounded-[40px] xl:rounded-[49px] " +
  "rounded-t-2xl xl:rounded-t-3xl shadow-xl dark:shadow-2xl " +
  "bg-white dark:bg-neutral-800";

const FlightSearch = () => {
  const provider = getActiveFlightSearchProvider();
  const title = `${provider.label} flight search`;

  return (
    <div className={WRAPPER_CLASS}>
      {provider.useIframeResizer ? (
        <IframeResizer
          log={false}
          src={provider.src}
          title={title}
          style={{ width: "1px", minWidth: "100%", border: "none" }}
          autoResize
          // taggedElement (not lowestElement): measures only the element
          // marked data-iframe-height in the child doc, so the iframe grows
          // AND shrinks with the real form. lowestElement also counts stray
          // absolutely-positioned Angular Material overlays, which linger
          // after collapse and stop the iframe from shrinking back.
          heightCalculationMethod="taggedElement"
          scrolling={true}
        />
      ) : (
        <iframe
          src={provider.src}
          title={title}
          style={{
            width: "100%",
            height: provider.fallbackHeight ?? "600px",
            border: "none",
          }}
        />
      )}
    </div>
  );
};

export default FlightSearch;
